import { IconButton, SvgIcon, TextField, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import type { ChangeEvent } from 'react';
import { useState } from 'react';
import { RequiredAsterisk } from '@/shared/ui';

const Wrapper = styled('label')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
}));
const LabelWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(0.25),
}));
const Input = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: theme.shape.borderRadius * 2,
  },

  '& .MuiInputBase-input': {
    padding: `${theme.spacing(1.5)} ${theme.spacing(2)}`,
    fontSize: '14px',
  },
  '& .MuiFormHelperText-root': {
    marginLeft: 0,
  },
}));
const VisibilityButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

interface Props {
  label: string;
  value: string;
  error: string;
  onChange: (v: string) => void;
  onBlur: () => void;
}

export function PasswordInput({
  label,
  error,
  value,
  onBlur,
  onChange,
}: Props) {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword((oldValue) => !oldValue);
  };
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <Wrapper>
      <LabelWrapper>
        <RequiredAsterisk />
        <Typography variant="label">{label}</Typography>
      </LabelWrapper>
      <Input
        error={!!error}
        helperText={error}
        value={value}
        type={showPassword ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <VisibilityButton size="small" onClick={toggleShowPassword}>
              {showPassword ? (
                <SvgIcon>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#7E828F"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </SvgIcon>
              ) : (
                <SvgIcon>
                  <svg
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.23317 8.23366C7.98755 8.46253 7.79054 8.73853 7.6539 9.0452C7.51726 9.35186 7.44379 9.68291 7.43786 10.0186C7.43194 10.3543 7.49369 10.6877 7.61943 10.999C7.74516 11.3103 7.93231 11.5931 8.16971 11.8305C8.4071 12.0678 8.68989 12.255 9.00118 12.3807C9.31247 12.5065 9.6459 12.5682 9.98158 12.5623C10.3173 12.5564 10.6483 12.4829 10.955 12.3463C11.2616 12.2096 11.5376 12.0126 11.7665 11.767M8.9415 4.23366C9.2926 4.18992 9.64603 4.16765 9.99984 4.16699C15.8332 4.16699 18.3332 10.0003 18.3332 10.0003C17.9606 10.7979 17.4934 11.5478 16.9415 12.2337M5.50817 5.50866C3.85088 6.63751 2.52473 8.18804 1.6665 10.0003C1.6665 10.0003 4.1665 15.8337 9.99984 15.8337C11.5964 15.8379 13.1588 15.3712 14.4915 14.492M1.6665 1.66699L18.3332 18.3337"
                      stroke="#7E828F"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </SvgIcon>
              )}
            </VisibilityButton>
          ),
        }}
        onBlur={onBlur}
        onChange={handleChange}
      />
    </Wrapper>
  );
}
